__turbopack_context__.v({
  "video_testimonial_carousel": "VideoWrapper-module-scss-module__yMH_lG__video_testimonial_carousel",
});
